
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { IWizard } from "../../../domain/format";
import { Document } from "../../../domain/document";
import { DocumentEditViewMixin } from ".";

@Component
export default class GuestWizardDocumentEditViewMixin extends Mixins(DocumentEditViewMixin) {
  @Prop()
  loadWizardTemplate: (id: number) => Promise<IWizard>;

  data(): any {
    return {
      wizard: null as IWizard,
    };
  }
  wizard: IWizard;

  async initializeNewWizardDocument(document: Document, orderNo: string, systemKey: string, linkKey: string, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, shouldThrowError: boolean = false): Promise<void> {
    await this.loadWizard(document.attributes.format.originalId);
    this.restrictExternalScripts(document, this.wizard);
    await this.initializeNewDocument(document, orderNo, systemKey, linkKey, institutionNo, regionalInstitutionNo, hisInfoGetterParameter, null, shouldThrowError);
  }

  async initializeExistingWizardDocument(document: Document, orderNo: string): Promise<void> {
    await this.loadWizard(document.attributes.format.originalId);
    this.restrictExternalScripts(document, this.wizard);
    await this.initializeExistingDocument(document, orderNo, null);
  }

  async initializeNewExtraWizardDocument(extraDocument: Document, document: Document): Promise<void> {
    console.warn("wizardテンプレートに指定した、実行を許可する外部処理をDocument.allowedExternalScriptsに設定する必要あり。未検証。");
    const wizard = await this.getWizard(extraDocument.attributes.format.originalId);
    this.restrictExternalScripts(extraDocument, wizard);
    await this.initializeNewExtraDocument(extraDocument, document);
  }

  private async loadWizard(formatOriginalId: number): Promise<void> {
    if (this.wizard) {
      return;
    }
    this.$logger.info("入力テンプレートをロードします.");
    this.wizard = this.loadWizardTemplate
      ? await this.loadWizardTemplate(formatOriginalId)
      : await this.getWizard(formatOriginalId);
    if (!this.wizard) {
      this.$fatal("テンプレート入力不可", "指定された" + this.$wording.format.name + "(" + formatOriginalId + ")の入力テンプレートがありません。");
    }
  }

  private async getWizard(formatOriginalId: number): Promise<IWizard> {
    try {
      return await DomainRegistry.instance.document.getDocumentRepository().getWizard(formatOriginalId, "guest");
    } catch (e) {
      console.error("指定された" + this.$wording.format.name + "(" + formatOriginalId + ")の入力テンプレートを取得できませんでした。");
      return null;
    }
  }

  private restrictExternalScripts(source: Document, wizard: IWizard): void {
    source.shouldRestrictExternalScript = true;
    source.allowedExternalScripts = (wizard && wizard.scripts)
      ? Enumerable.from(wizard.scripts).select(s => s.allowed).toArray()
      : null;
  }
}
